import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import Cookies from 'js-cookie';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';


@Injectable()
export class ErpService {

    httpOptions = {
        withCredentials: false,
        headers: null
    }

    constructor(private http: HttpClient) {}

    create(data: object = null): Observable<any> {
        if (Cookies.get('csrftoken')) {
            this.httpOptions = {
                withCredentials: true,
                headers: new HttpHeaders({
                    'X-CSRFToken': Cookies.get('csrftoken')
                })
            };
        }
        return this.http.post(environment.apiUrl + 'erp/update_create_customer/', data, this.httpOptions);
    }

    get_olap_erp_loan_app(id: any = null, data: object = null): Observable<any> {
        if (Cookies.get('csrftoken')) {
            this.httpOptions = {
                withCredentials: true,
                headers: new HttpHeaders({
                    'X-CSRFToken': Cookies.get('csrftoken')
                })
            };
        }
        return this.http.post(environment.apiUrl + 'erp/get_olap_erp_loan_app/' + id, data, this.httpOptions);
    }

    integrateAndRenewLoanApp(data: object = null): Observable<any> {
      if (Cookies.get('csrftoken')) {
          this.httpOptions = {
              withCredentials: true,
              headers: new HttpHeaders({
                  'X-CSRFToken': Cookies.get('csrftoken')
              })
          };
      }
      return this.http.post(environment.apiUrl + 'erp/renew_loan_app/', data, this.httpOptions);
    }

}



// WEBPACK FOOTER //
// /opt/tglfc/olap/salary_web/src/app/service/erp.service.ts